// @flow

import React from 'react';
import { EmbeddedUrl } from '../../../../types/embeddedUrlTypes';
import embeddedUrlApi from '../../../../network/api/embeddedUrlApi';
import Loader from '../../../common/Loader';

type Props = {
  cssClass: string,
  pageName: string,
}

type State = {
  currentEmbeddedUrl: EmbeddedUrl,
  embeddedUrls: EmbeddedUrl[],
  isEmbeddedUrlLoading: string,
}

class EmbeddedUrlPage extends React.Component<Props, State> {
  state: State = {
    currentEmbeddedUrl: null,
    embeddedUrls: [],
    isEmbeddedUrlLoading: true,
  };

  componentDidMount() {
    embeddedUrlApi.fetchEmbeddedUrlByPage(this.props.pageName)
      .then(resp => resp.json())
      .then((json: EmbeddedUrl[]) => {
        this.setState({ embeddedUrls: json });
      })
      .finally(() => {
        this.setState({
          isEmbeddedUrlLoading: false,
        });
      });
  }

  sortTabByOrder = (a: EmbeddedUrl, b: EmbeddedUrl) => {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  };

  updateUrl = (tab: EmbeddedUrl) => {
    this.setState({ currentEmbeddedUrl: tab });
  };

  currentTab = (defaultSelected: EmbeddedUrl) => (this.state.currentEmbeddedUrl ? this.state.currentEmbeddedUrl : defaultSelected);

  render() {
    if (this.state.isEmbeddedUrlLoading) {
      return (<Loader />);
    }
    const embeddedUrls = this.state.embeddedUrls.sort(this.sortTabByOrder);
    const defaultTab = embeddedUrls[0];
    const currentTab = this.currentTab(defaultTab);
    return (
      <div className={`embedded-url-container ${this.props.cssClass}-container`}>
        <div className={`tab-router-header ${this.props.cssClass}-header`}>
          {
            this.state.embeddedUrls
              .sort(this.sortTabByOrder)
              .map((embeddedUrl: EmbeddedUrl) => (
                <button
                  key={embeddedUrl.id}
                  className={`tab-router-tile ${this.props.cssClass}-subtitle ${embeddedUrl.tabTitle === currentTab.tabTitle ? 'selected' : ''}`}
                  onClick={() => this.updateUrl(embeddedUrl)}
                >
                  {embeddedUrl.tabTitle.toUpperCase()}
                  <div
                    className={`underline ${this.props.cssClass}-subtitle ${embeddedUrl.tabTitle === currentTab.tabTitle ? 'selected' : ''}`}
                  />
                </button>
                ))
          }
        </div>
        {
          currentTab
          && (
            <div className="iframe-wrapper">
              <iframe
                title={currentTab.tabTitle}
                src={currentTab.iframeLink}
              />
            </div>
          )
        }
      </div>
    );
  }
}

export default EmbeddedUrlPage;
